import { call, select } from 'redux-saga/effects';
import { userNameDecrypted } from 'features/e2ee/actions';
import { selectAwaitingEntryIds, selectUserById } from 'features/users/usersSlice';
import { User, UserId } from 'features/users/types';
import { sendWaitingUsersJoinedSaga } from 'features/users/sagas/sendWaitingUsersJoinedSaga';

export function* onWaitingUserNameDecryptedSaga(action: ReturnType<typeof userNameDecrypted>) {
  const awaitingEntryIds: UserId[] = yield select(selectAwaitingEntryIds);
  if (!awaitingEntryIds.includes(action.payload.id)) {
    return;
  }

  const user: User | undefined = yield select(selectUserById, action.payload.id);
  if (!user) {
    return;
  }

  yield call(sendWaitingUsersJoinedSaga, [user]);
}
